(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["convention-slideshow"] && !Shopify.designMode) return;
  try {
    
jQuery(function() {
$(document).on('shopify:section:select', function(){
THEME.initialization.mainSlider('.bnslider');
THEME.initialization.hoverColor();
THEME.initialization.setFullHeightSlider('.bnslider--fullheight');
})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-faq"]) return;
  try {
    
$(document).ready(function(){
	// Add minus icon for collapse element which is open by default
	$(".collapse.show").each(function(){
		$(this).prev(".card-header").addClass("highlight");
	});
	
	// Highlight open collapsed element 
	$(".card-header .btn").click(function(){
		$(".card-header").not($(this).parents()).removeClass("highlight");
		$(this).parents(".card-header").toggleClass("highlight");
	});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-slideshow"] && !Shopify.designMode) return;
  try {
    
jQuery(function() {
$(document).on('shopify:section:select', function(){
THEME.initialization.mainSlider('.bnslider');
THEME.initialization.hoverColor();
THEME.initialization.setFullHeightSlider('.bnslider--fullheight');
})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
jQuery(function() {
$(document).on('shopify:section:select', function(){
THEME.initialization.mainSlider('.bnslider');
THEME.initialization.hoverColor();
THEME.initialization.setFullHeightSlider('.bnslider--fullheight');
})
});

  } catch(e) { console.error(e); }
})();
})();
